module.exports = __webpack_public_path__ + "img/logo-comment.46efe889.svg";